<div class="flex flex-col gap-4">
  <div class="flex flex-wrap items-center justify-end gap-2">
    <xemex-outlined-button type="button" icon="view_column" [matMenuTriggerFor]="columnMenu">
      {{ 'installations.data.columns' | translate: columnCount() }}
    </xemex-outlined-button>
    <xemex-outlined-button
      type="button"
      icon="download"
      [disabled]="rows().length === 0"
      (click)="downloadCsv()"
    >
      {{ 'installations.data.download' | translate }}
    </xemex-outlined-button>
  </div>

  <mat-menu #columnMenu="matMenu">
    @for (point of points(); track point.pointId) {
      <div class="px-4 py-1" (click)="$event.stopPropagation()">
        <mat-checkbox [checked]="isSelected(point)" (change)="toggle(point)">
          {{ pointHeader(point) }}
          @if (point.state === 'hidden') {
            <span class="text-text-secondary">
              ({{ 'installations.data.hidden' | translate }})</span
            >
          }
        </mat-checkbox>
      </div>
    }
  </mat-menu>

  <xemex-table
    style="max-height: 624px"
    [data]="rows()"
    [columns]="columns()"
    [pageable]="false"
    [compact]="true"
    [loading]="telemetryStore.isLoading()"
  ></xemex-table>
</div>
